import { Route } from "react-router-dom";
import { StripePayment } from "features/payment";

import CreditsPricing from "features/credits/pages/CreditsPricing";
import DashboardPro from "features/dashboard-pro/pages/DashboardPro";
import DatabaseDocuments from "features/documents/pages/DatabaseDocuments";
import DocumentVerificationStatsPage from "features/stats/pages/DocumentVerificationStats/DocumentVerificationStatsPage";
import Faq from "pages/Faq";
import FiligraneImporterPage from "features/filigrane/pages/FiligraneImporter/FiligraneImporterPage";
import Folder from "features/documents/pages/IDLockerDetail";
import FraudWizardPage from "features/fraud/pages/FraudFromUrlOrImage/FraudWizardPage";
import IDLockerFlow from "features/documents/pages/IDLocker/IDLockerFlow";
import IDLockerList from "features/documents/pages/IDLockerList";
import IDTrackerPricing from "features/breaches/pages/IDTrackerPricing";
import Layout from "components/Layout";
import NotificationAll from "features/notifications/pages/NotificationAll";
import Profil from "features/account/pages/Profil";
import SignalerDocumentPage from "features/signaler-document/pages/SignalerDocumentPage/SignalerDocumentPage";
import PartnerAdminRoute from "./PartnerAdminRoute";
import Verify from "features/analysis/pages/Verify";
export const partnerRoutesOpen = (
    <>
      <Route
        path="/professionnels/faq"
        element={
          <Layout>
            <Faq />
          </Layout>
        }
      />
      <Route
        path="/professionnels/filter"
        element={
          <Layout>
            <FiligraneImporterPage />
          </Layout>
      }
      />
    </>
  );

export const partnerRoutesProtected = (
    <>
      {/* SI Non ADV alors */}
      {(process.env?.REACT_APP_FOR_PARTNER_ONLY ?? "0") === "0" && (
        <>
          <Route
            path="/professionnels/dashboard"
            element={
              <Layout>
                <DashboardPro />
              </Layout>
            }
          />

          <Route
            path="/professionnels/dark-web"
            element={
              <Layout>
                <Verify isDarkWeb />
              </Layout>
            }
          />

          <Route
            path="/professionnels/fraud/leboncoin"
            element={
              <Layout>
                <FraudWizardPage />
              </Layout>
            }
          />

          <Route
            path="/professionnels/credits-pricing"
            element={
              <Layout>
                <CreditsPricing />
              </Layout>
            }
          />
          <Route
            path="/professionnels/id-tracker-pricing"
            element={
              <Layout>
                <IDTrackerPricing />
              </Layout>
            }
          />
          <Route
            path="/professionnels/payment/:offer/:planIndex/:isMonth"
            element={
              <Layout>
                <StripePayment />
              </Layout>
            }
          />
        </>
      )}

      {/*whatever ADV or not*/}

      <Route
        path="/professionnels/id-locker/creer_dossier"
        element={
          <Layout>
            <IDLockerFlow/>
          </Layout>
        }
      />

      <Route
        path="/professionnels/verifier-document"
        element={
          <Layout>
            <Verify />
          </Layout>
        }
      />

      <Route
        path="/professionnels/signaler-document"
        element={
          <PartnerAdminRoute>
            <Layout>
              <SignalerDocumentPage />
            </Layout>
          </PartnerAdminRoute>
        }
      />

      <Route
        path="/professionnels/base-de-donnees"
        element={
          <Layout>
            <DatabaseDocuments />
          </Layout>
        }
      />

      <Route
        path="/professionnels/id-locker/"
        element={
          <Layout>
            <IDLockerList />
          </Layout>
        }
      />

      <Route
        path="/professionnels/id-locker/:id"
        element={
          <Layout>
            <Folder />
          </Layout>
        }
      />

      <Route
        path="/professionnels/profil"
        element={
          <Layout>
            <Profil />
          </Layout>
        }
      />

      <Route
        path="/professionnels/notifications"
        element={
          <Layout>
            <NotificationAll />
          </Layout>
        }
      />

      <Route
        path="/professionnels/doc-request-stats"
        element={
          <Layout>
            <DocumentVerificationStatsPage />
          </Layout>
        }
      />

    </>
  );
